import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import {Typography} from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import { useNavigate } from "react-router-dom";
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';

const WebViewAddReffSukses = () => {

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton:false
		// 	});
		// }
	}, []);
	const [openSnK, setOpenSnk] = React.useState(false);

	const descriptionElementRef = React.useRef(null);
	React.useEffect(() => {
		if (openSnK) {
			const { current: descriptionElement } = descriptionElementRef;
			if (descriptionElement !== null) {
				descriptionElement.focus();
			}
		}
	}, [openSnK]);

	const navigate = useNavigate();

	const navigateToLogin = () => {
		// 👇️ navigate to /demoLoginWebView
		navigate('/webViewLogin');
	};


    return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Referral Listing"}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>
				{/* 🔥 typography */}
				<Typography sx={{mt: 2}} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Registrasi Referrer berhasil, silakan cek email Referrer untuk konfirmasi data Referrer</Typography>
				<Div sx={{
				p: '40px 24px',
				flex: 1,
				alignItems: 'center',
				justifyContent: 'center',
			    }}>
				<img src={`${process.env.REACT_APP_IMAGES_PATH}/Registersukses.svg`} width={265} height={265} />
			    </Div>
			</ContentWrapper>

			{/* 🔥 FOOTER */}
			<MobileFooter>
				
				<ButtonStyled 
					btnText={"Kembali Ke Menu Referral"}
					preset={"primary"}
					onClick={navigateToLogin}
				/>
			</MobileFooter>
			

		</Div>
        
    );
};

export default WebViewAddReffSukses;